'use strict';

routesConfig.$inject = ["$stateProvider", "$urlRouterProvider", "$locationProvider"];
var cov_1jr5bbbztl = function () {
  var path = '/home/rwaltenberg/Projects/moneycounter/src/index.js',
      hash = 'cc19aa2b44edeeb6f1aa3c5fba4f541b2476ac81',
      global = new Function('return this')(),
      gcv = '__coverage__',
      coverageData = {
    path: '/home/rwaltenberg/Projects/moneycounter/src/index.js',
    statementMap: {
      '0': {
        start: {
          line: 1,
          column: 0
        },
        end: {
          line: 2,
          column: 32
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      '0': 0
    },
    f: {},
    b: {},
    _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

++cov_1jr5bbbztl.s[0];
angular.module('app', ['ui.router']);
'use strict';

var cov_gpndzbzcl = function () {
  var path = '/home/rwaltenberg/Projects/moneycounter/src/app/counting/counting.js',
      hash = 'e576f3e00b9054727d4326b04ea9551abf7722b5',
      global = new Function('return this')(),
      gcv = '__coverage__',
      coverageData = {
    path: '/home/rwaltenberg/Projects/moneycounter/src/app/counting/counting.js',
    statementMap: {
      '0': {
        start: {
          line: 1,
          column: 0
        },
        end: {
          line: 43,
          column: 5
        }
      },
      '1': {
        start: {
          line: 6,
          column: 19
        },
        end: {
          line: 6,
          column: 23
        }
      },
      '2': {
        start: {
          line: 8,
          column: 6
        },
        end: {
          line: 8,
          column: 19
        }
      },
      '3': {
        start: {
          line: 10,
          column: 6
        },
        end: {
          line: 17,
          column: 8
        }
      },
      '4': {
        start: {
          line: 19,
          column: 6
        },
        end: {
          line: 22,
          column: 8
        }
      },
      '5': {
        start: {
          line: 20,
          column: 8
        },
        end: {
          line: 20,
          column: 42
        }
      },
      '6': {
        start: {
          line: 21,
          column: 8
        },
        end: {
          line: 21,
          column: 20
        }
      },
      '7': {
        start: {
          line: 24,
          column: 6
        },
        end: {
          line: 31,
          column: 8
        }
      },
      '8': {
        start: {
          line: 25,
          column: 8
        },
        end: {
          line: 28,
          column: 11
        }
      },
      '9': {
        start: {
          line: 26,
          column: 10
        },
        end: {
          line: 26,
          column: 26
        }
      },
      '10': {
        start: {
          line: 27,
          column: 10
        },
        end: {
          line: 27,
          column: 22
        }
      },
      '11': {
        start: {
          line: 30,
          column: 8
        },
        end: {
          line: 30,
          column: 20
        }
      },
      '12': {
        start: {
          line: 34,
          column: 8
        },
        end: {
          line: 40,
          column: 11
        }
      },
      '13': {
        start: {
          line: 35,
          column: 10
        },
        end: {
          line: 37,
          column: 11
        }
      },
      '14': {
        start: {
          line: 36,
          column: 12
        },
        end: {
          line: 36,
          column: 42
        }
      },
      '15': {
        start: {
          line: 39,
          column: 10
        },
        end: {
          line: 39,
          column: 47
        }
      }
    },
    fnMap: {
      '0': {
        name: '(anonymous_0)',
        decl: {
          start: {
            line: 19,
            column: 26
          },
          end: {
            line: 19,
            column: 27
          }
        },
        loc: {
          start: {
            line: 19,
            column: 45
          },
          end: {
            line: 22,
            column: 7
          }
        }
      },
      '1': {
        name: '(anonymous_1)',
        decl: {
          start: {
            line: 24,
            column: 19
          },
          end: {
            line: 24,
            column: 20
          }
        },
        loc: {
          start: {
            line: 24,
            column: 25
          },
          end: {
            line: 31,
            column: 7
          }
        }
      },
      '2': {
        name: '(anonymous_2)',
        decl: {
          start: {
            line: 25,
            column: 36
          },
          end: {
            line: 25,
            column: 37
          }
        },
        loc: {
          start: {
            line: 25,
            column: 44
          },
          end: {
            line: 28,
            column: 9
          }
        }
      },
      '3': {
        name: 'updateSum',
        decl: {
          start: {
            line: 33,
            column: 15
          },
          end: {
            line: 33,
            column: 24
          }
        },
        loc: {
          start: {
            line: 33,
            column: 27
          },
          end: {
            line: 41,
            column: 7
          }
        }
      },
      '4': {
        name: '(anonymous_4)',
        decl: {
          start: {
            line: 34,
            column: 37
          },
          end: {
            line: 34,
            column: 38
          }
        },
        loc: {
          start: {
            line: 34,
            column: 47
          },
          end: {
            line: 40,
            column: 9
          }
        }
      }
    },
    branchMap: {
      '0': {
        loc: {
          start: {
            line: 35,
            column: 10
          },
          end: {
            line: 37,
            column: 11
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 35,
            column: 10
          },
          end: {
            line: 37,
            column: 11
          }
        }, {
          start: {
            line: 35,
            column: 10
          },
          end: {
            line: 37,
            column: 11
          }
        }]
      },
      '1': {
        loc: {
          start: {
            line: 36,
            column: 17
          },
          end: {
            line: 36,
            column: 30
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 36,
            column: 17
          },
          end: {
            line: 36,
            column: 25
          }
        }, {
          start: {
            line: 36,
            column: 29
          },
          end: {
            line: 36,
            column: 30
          }
        }]
      },
      '2': {
        loc: {
          start: {
            line: 39,
            column: 22
          },
          end: {
            line: 39,
            column: 35
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 39,
            column: 22
          },
          end: {
            line: 39,
            column: 30
          }
        }, {
          start: {
            line: 39,
            column: 34
          },
          end: {
            line: 39,
            column: 35
          }
        }]
      }
    },
    s: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0,
      '7': 0,
      '8': 0,
      '9': 0,
      '10': 0,
      '11': 0,
      '12': 0,
      '13': 0,
      '14': 0,
      '15': 0
    },
    f: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0
    },
    b: {
      '0': [0, 0],
      '1': [0, 0],
      '2': [0, 0]
    },
    _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

++cov_gpndzbzcl.s[0];
angular.module('app').component('counting', {
  templateUrl: 'app/counting/counting.html',
  controller: function controller() {
    var ctrl = (++cov_gpndzbzcl.s[1], this);

    ++cov_gpndzbzcl.s[2];
    ctrl.sum = 0;

    ++cov_gpndzbzcl.s[3];
    ctrl.bills = [{ value: 100, color: '#cdeaf0' }, { value: 50, color: '#f8e8c7' }, { value: 20, color: '#f9efcc' }, { value: 10, color: '#f2d0c7' }, { value: 5, color: '#f1ecf3' }, { value: 2, color: '#d9ecfa' }];

    ++cov_gpndzbzcl.s[4];
    ctrl.updateAmount = function (index, amount) {
      ++cov_gpndzbzcl.f[0];
      ++cov_gpndzbzcl.s[5];

      ctrl.bills[index].amount = amount;
      ++cov_gpndzbzcl.s[6];
      updateSum();
    };

    ++cov_gpndzbzcl.s[7];
    ctrl.reset = function () {
      ++cov_gpndzbzcl.f[1];
      ++cov_gpndzbzcl.s[8];

      ctrl.bills = ctrl.bills.map(function (item) {
        ++cov_gpndzbzcl.f[2];
        ++cov_gpndzbzcl.s[9];

        item.amount = 0;
        ++cov_gpndzbzcl.s[10];
        return item;
      });

      ++cov_gpndzbzcl.s[11];
      updateSum();
    };

    function updateSum() {
      ++cov_gpndzbzcl.f[3];
      ++cov_gpndzbzcl.s[12];

      ctrl.sum = ctrl.bills.reduce(function (a, b) {
        ++cov_gpndzbzcl.f[4];
        ++cov_gpndzbzcl.s[13];

        if (angular.isObject(a)) {
          ++cov_gpndzbzcl.b[0][0];
          ++cov_gpndzbzcl.s[14];

          a = ((++cov_gpndzbzcl.b[1][0], a.amount) || (++cov_gpndzbzcl.b[1][1], 0)) * a.value;
        } else {
          ++cov_gpndzbzcl.b[0][1];
        }

        ++cov_gpndzbzcl.s[15];
        return a + ((++cov_gpndzbzcl.b[2][0], b.amount) || (++cov_gpndzbzcl.b[2][1], 0)) * b.value;
      });
    }
  }
});
'use strict';

var cov_1cb4db29fc = function () {
  var path = '/home/rwaltenberg/Projects/moneycounter/src/app/bill/bill.js',
      hash = '076e2ad59774523daab352c349646f6c710ee9e5',
      global = new Function('return this')(),
      gcv = '__coverage__',
      coverageData = {
    path: '/home/rwaltenberg/Projects/moneycounter/src/app/bill/bill.js',
    statementMap: {
      '0': {
        start: {
          line: 3,
          column: 0
        },
        end: {
          line: 40,
          column: 5
        }
      },
      '1': {
        start: {
          line: 14,
          column: 19
        },
        end: {
          line: 14,
          column: 23
        }
      },
      '2': {
        start: {
          line: 15,
          column: 6
        },
        end: {
          line: 15,
          column: 19
        }
      },
      '3': {
        start: {
          line: 17,
          column: 6
        },
        end: {
          line: 24,
          column: 8
        }
      },
      '4': {
        start: {
          line: 18,
          column: 26
        },
        end: {
          line: 18,
          column: 47
        }
      },
      '5': {
        start: {
          line: 19,
          column: 8
        },
        end: {
          line: 19,
          column: 29
        }
      },
      '6': {
        start: {
          line: 20,
          column: 8
        },
        end: {
          line: 20,
          column: 31
        }
      },
      '7': {
        start: {
          line: 22,
          column: 8
        },
        end: {
          line: 22,
          column: 90
        }
      },
      '8': {
        start: {
          line: 23,
          column: 8
        },
        end: {
          line: 23,
          column: 51
        }
      },
      '9': {
        start: {
          line: 26,
          column: 6
        },
        end: {
          line: 29,
          column: 8
        }
      },
      '10': {
        start: {
          line: 27,
          column: 8
        },
        end: {
          line: 27,
          column: 50
        }
      },
      '11': {
        start: {
          line: 28,
          column: 8
        },
        end: {
          line: 28,
          column: 29
        }
      },
      '12': {
        start: {
          line: 31,
          column: 6
        },
        end: {
          line: 38,
          column: 8
        }
      },
      '13': {
        start: {
          line: 32,
          column: 8
        },
        end: {
          line: 32,
          column: 44
        }
      },
      '14': {
        start: {
          line: 34,
          column: 8
        },
        end: {
          line: 37,
          column: 9
        }
      },
      '15': {
        start: {
          line: 35,
          column: 23
        },
        end: {
          line: 35,
          column: 59
        }
      },
      '16': {
        start: {
          line: 36,
          column: 10
        },
        end: {
          line: 36,
          column: 37
        }
      }
    },
    fnMap: {
      '0': {
        name: '(anonymous_0)',
        decl: {
          start: {
            line: 17,
            column: 24
          },
          end: {
            line: 17,
            column: 25
          }
        },
        loc: {
          start: {
            line: 17,
            column: 30
          },
          end: {
            line: 24,
            column: 7
          }
        }
      },
      '1': {
        name: '(anonymous_1)',
        decl: {
          start: {
            line: 26,
            column: 23
          },
          end: {
            line: 26,
            column: 24
          }
        },
        loc: {
          start: {
            line: 26,
            column: 33
          },
          end: {
            line: 29,
            column: 7
          }
        }
      },
      '2': {
        name: '(anonymous_2)',
        decl: {
          start: {
            line: 31,
            column: 27
          },
          end: {
            line: 31,
            column: 28
          }
        },
        loc: {
          start: {
            line: 31,
            column: 33
          },
          end: {
            line: 38,
            column: 7
          }
        }
      }
    },
    branchMap: {
      '0': {
        loc: {
          start: {
            line: 23,
            column: 20
          },
          end: {
            line: 23,
            column: 36
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 23,
            column: 20
          },
          end: {
            line: 23,
            column: 31
          }
        }, {
          start: {
            line: 23,
            column: 35
          },
          end: {
            line: 23,
            column: 36
          }
        }]
      },
      '1': {
        loc: {
          start: {
            line: 27,
            column: 23
          },
          end: {
            line: 27,
            column: 39
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 27,
            column: 23
          },
          end: {
            line: 27,
            column: 34
          }
        }, {
          start: {
            line: 27,
            column: 38
          },
          end: {
            line: 27,
            column: 39
          }
        }]
      },
      '2': {
        loc: {
          start: {
            line: 34,
            column: 8
          },
          end: {
            line: 37,
            column: 9
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 34,
            column: 8
          },
          end: {
            line: 37,
            column: 9
          }
        }, {
          start: {
            line: 34,
            column: 8
          },
          end: {
            line: 37,
            column: 9
          }
        }]
      }
    },
    s: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0,
      '7': 0,
      '8': 0,
      '9': 0,
      '10': 0,
      '11': 0,
      '12': 0,
      '13': 0,
      '14': 0,
      '15': 0,
      '16': 0
    },
    f: {
      '0': 0,
      '1': 0,
      '2': 0
    },
    b: {
      '0': [0, 0],
      '1': [0, 0],
      '2': [0, 0]
    },
    _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

++cov_1cb4db29fc.s[0];
/* global tinycolor */

angular.module('app').component('bill', {
  templateUrl: 'app/bill/bill.html',
  bindings: {
    value: '@',
    color: '@',
    amount: '<',
    onAmountChanged: '&'
  },
  controller: function controller() {
    var ctrl = (++cov_1cb4db29fc.s[1], this);
    ++cov_1cb4db29fc.s[2];
    ctrl.sum = 0;

    ++cov_1cb4db29fc.s[3];
    ctrl.$onChanges = function () {
      ++cov_1cb4db29fc.f[0];

      var fontColor = (++cov_1cb4db29fc.s[4], tinycolor(ctrl.color));
      ++cov_1cb4db29fc.s[5];
      fontColor.darken(50);
      ++cov_1cb4db29fc.s[6];
      fontColor.saturate(10);

      ++cov_1cb4db29fc.s[7];
      ctrl.bgcolor = { "background-color": ctrl.color, "color": fontColor.toHexString() };
      ++cov_1cb4db29fc.s[8];
      ctrl.sum = ((++cov_1cb4db29fc.b[0][0], ctrl.amount) || (++cov_1cb4db29fc.b[0][1], 0)) * ctrl.value;
    };

    ++cov_1cb4db29fc.s[9];
    ctrl.addAmount = function (amount) {
      ++cov_1cb4db29fc.f[1];
      ++cov_1cb4db29fc.s[10];

      ctrl.amount = ((++cov_1cb4db29fc.b[1][0], ctrl.amount) || (++cov_1cb4db29fc.b[1][1], 0)) + amount;
      ++cov_1cb4db29fc.s[11];
      ctrl.amountChanged();
    };

    ++cov_1cb4db29fc.s[12];
    ctrl.amountChanged = function () {
      ++cov_1cb4db29fc.f[2];
      ++cov_1cb4db29fc.s[13];

      ctrl.sum = ctrl.amount * ctrl.value;

      ++cov_1cb4db29fc.s[14];
      if (ctrl.onAmountChanged) {
        ++cov_1cb4db29fc.b[2][0];

        var args = (++cov_1cb4db29fc.s[15], { amount: ctrl.amount, sum: ctrl.sum });
        ++cov_1cb4db29fc.s[16];
        ctrl.onAmountChanged(args);
      } else {
        ++cov_1cb4db29fc.b[2][1];
      }
    };
  }
});
angular.module("app").run(["$templateCache", function($templateCache) {$templateCache.put("app/bill/bill.html","<button class=\"btn bill__button\" ng-style=\"$ctrl.bgcolor\" ng-click=\"$ctrl.addAmount(1)\">{{ $ctrl.value }}</button>\n<span class=\"bill__times\">&times;</span>\n<input type=\"number\" min=\"0\" ng-change=\"$ctrl.amountChanged(amount)\" ng-model=\"$ctrl.amount\">\n<span class=\"bill__equals\">&equals;</span>\n<span class=\"bill__sum\">{{ $ctrl.sum | number }}</span>\n");
$templateCache.put("app/counting/counting.html","<header>\n  <h1>Conta Grana</h1>\n  <h2>Conte seu dinheiro com facilidade!</h2>\n</header>\n<main>\n  <div class=\"counting__bills\">\n    <bill ng-repeat=\"bill in $ctrl.bills\" value=\"{{ bill.value }}\" color=\"{{ bill.color }}\" amount=\"bill.amount\" on-amount-changed=\"$ctrl.updateAmount($index, amount)\">\n  </div>\n  <button ng-click=\"$ctrl.reset()\" class=\"btn btn-sm btn-danger counting__reset\">Limpar</button>\n  <span class=\"counting__sum\">\n    R$ {{ $ctrl.sum | number:2 }}\n  </span>\n</main>\n<footer>\n  Conta Grana - GNU v3\n  <small>\n    Por <span class=\"author\">Rodrigo Waltenberg</span>\n  </small>\n</footer>\n");}]);
'use strict';

var cov_1menjz7sai = function () {
  var path = '/home/rwaltenberg/Projects/moneycounter/src/routes.js',
      hash = '34015cb60a3caf53d76495d665efea5851863af9',
      global = new Function('return this')(),
      gcv = '__coverage__',
      coverageData = {
    path: '/home/rwaltenberg/Projects/moneycounter/src/routes.js',
    statementMap: {
      '0': {
        start: {
          line: 1,
          column: 0
        },
        end: {
          line: 3,
          column: 24
        }
      },
      '1': {
        start: {
          line: 7,
          column: 2
        },
        end: {
          line: 7,
          column: 52
        }
      },
      '2': {
        start: {
          line: 8,
          column: 2
        },
        end: {
          line: 8,
          column: 36
        }
      },
      '3': {
        start: {
          line: 10,
          column: 2
        },
        end: {
          line: 14,
          column: 7
        }
      }
    },
    fnMap: {
      '0': {
        name: 'routesConfig',
        decl: {
          start: {
            line: 6,
            column: 9
          },
          end: {
            line: 6,
            column: 21
          }
        },
        loc: {
          start: {
            line: 6,
            column: 77
          },
          end: {
            line: 15,
            column: 1
          }
        }
      }
    },
    branchMap: {},
    s: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0
    },
    f: {
      '0': 0
    },
    b: {},
    _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

++cov_1menjz7sai.s[0];
angular.module('app').config(routesConfig);

/** @ngInject */
function routesConfig($stateProvider, $urlRouterProvider, $locationProvider) {
  ++cov_1menjz7sai.f[0];
  ++cov_1menjz7sai.s[1];

  $locationProvider.html5Mode(true).hashPrefix('!');
  ++cov_1menjz7sai.s[2];
  $urlRouterProvider.otherwise('/');

  ++cov_1menjz7sai.s[3];
  $stateProvider.state('main', {
    url: '/',
    component: 'counting'
  });
}